var App = function() {
    'use strict';

    var _resizeTimeout;

    var _onResize = function () {
        console.log('onResize');

        // wh = $(window).height();
        //
        // var headerHeight = $('.masthead').height();
        // var viewportHeight = $('.viewport').outerHeight();
        // var footerHeight = $('.footer').outerHeight();
        // var gotopHeight = $('.gotop__wrap').outerHeight();
        //
        // // $('.viewport').css({
        // //     //'padding-top': headerHeight + 'px',
        // //     'min-height': (wh - footerHeight - 5) + 'px'
        // // });
        // var mastheadHeight = viewportHeight + gotopHeight;
        //
        // if (wh - footerHeight > viewportHeight + gotopHeight) {
        //     mastheadHeight = wh - footerHeight;
        // }
        //
        // $('.masthead, .el_fixed_parent').css({
        //     //'padding-top': headerHeight + 'px',
        //     'min-height': mastheadHeight + 'px'
        // });
    };

    var _resizeHandler = function() {
        clearTimeout(_resizeTimeout);
        _resizeTimeout = setTimeout(_onResize, 150);
    };

    /**
     * onScroll handler
     */
    var _onScroll = function(event) {
        // var $fixedElement = $('.el_fixed'),
        //     fixedElHeight = $fixedElement.height(),
        //
        //     $rootElement = $('body'),
        //     rootElHeight = $rootElement.height(),
        //
        //     $parentElement = $('.el_fixed_parent'),
        //     parentElHeight = $parentElement.height(),
        //
        //     paddingBottom = 50,
        //     scrollTopValue = 0,
        //     windowWidth = $(window).width();
        //
        // if (windowWidth > 768) {
        //     scrollTopValue = $(window).scrollTop();
        //     //$parentElement.height(rootElHeight);
        //     //parentElHeight = rootElHeight;
        // } else {
        //     //$parentElement.css('height', '');
        // }
        //
        // // console.log('--');
        // // console.log('parentElHeight', parentElHeight);
        // // console.log('fixedElHeight', fixedElHeight);
        // // console.log('scrollTopValue', scrollTopValue);
        //
        // if (( parentElHeight - paddingBottom - fixedElHeight ) <= scrollTopValue) {
        //     $fixedElement
        //         .removeClass('el_fixed--fixed')
        //         .addClass('el_fixed--bottom');
        // } else {
        //     $fixedElement
        //         .removeClass('el_fixed--bottom')
        //         .addClass('el_fixed--fixed');
        // }
    };


    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    var _scrollToElement = function (elementId) {
        if ($('#' + elementId).length) {
            $('html, body').animate({
                scrollTop: $('#' + elementId).offset().top - 135
            }, 1200, 'easeInOutQuart');
        } else {
            if (isNumeric(elementId)) {
                $('html, body').animate({
                    scrollTop: elementId - 135
                }, 100, 'easeInOutQuart');
            }
        }
    };

    var _initHistoryHandler = function () {
        var State = History.getState();

        History.log('History - old state:', State.data, State.title, State.url);

        History.Adapter.bind(window, 'statechange', function () {
            // Note: We are using statechange instead of popstate
            var partial_url;

            var State = History.getState(); // Note: We are using History.getState() instead of event.state
            var data = State.data;

            console.info('Data: ', data);
            console.info('data.load_partial', data.load_partial);

            if (data.load_partial) {
                if (data.load_partial == partial_url) {
                    console.log('partial_url', partial_url);
                    console.log('data.load_partial', data.load_partial);
                    _onResize();
                    _scrollToElement(data.scroll_to);
                } else {
                    partial_url = data.load_partial;
                    $('body').addClass('loading');

                    _allPagesAnimateOut(function () {
                        $.ajax({
                            type: "get",
                            url: data.load_partial,
                            beforeSend: function (request) {
                                // do something clever
                            },
                            dataType: 'html'
                        })
                            .done(function (markup, textStatus, jqXHR) {
                                var $wrapper = $('.page-row-expanded');

                                var $viewport = $(markup).find('.viewport');
                                var viewportTemplate = $viewport.data('template');

                                console.log('$viewport', $viewport);
                                console.log('viewportTemplate', viewportTemplate);

                                if (viewportTemplate) {
                                    $('body').removeClassStartingWith('template');
                                    $('body').addClass('template_' + viewportTemplate);
                                }

                                $wrapper.html($viewport);
                                $wrapper.imagesLoaded(function() {
                                    _onResize();
                                    _onScroll();
                                });

                                $(document).on('lazyloaded', function(){
                                    _onScroll();
                                });

                                _allPagesAnimateIn(function () {
                                    initializeForm();
                                    $('body').removeClass('loading');
                                    if (data.scroll_to) {
                                        _scrollToElement(data.scroll_to)
                                    } else {
                                        _scrollToElement(135);
                                    }
                                });
                            })
                            .fail(function (jqXHR, textStatus, errorThrown) {
                                console.log('ajax failed', textStatus);
                            })
                            .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                                // do something
                            });
                    });
                }
            }

            History.log('New-state: ', State.data, State.title, State.url);
        });
    };

    /**
     * Open external links in another tab (or window)
     * <a rel='external' ... > ... </a>
     * @private
     */
    var _enableExternalLinks = function() {
        $('a[rel*=external]').on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            var $button = $(this),
                href = $button.attr('href'),
                noProtocol = href.replace(/http[s]?:\/\//, '');

            // check if Google Analytics tracking code is loaded and initialized
            if (typeof ga === 'function') {

                // track Google Analytics event
                ga('send', 'event', 'external', 'click', noProtocol, '', {
                    'nonInteraction': true
                });
            }

            // open new tab/window for the clicked link
            window.open(href);
        });
    };

    /**
     * Smooth scroll to the top of the page
     * @private
     */
    var _goTopClick = function () {
        $('.gotop__link').on('click', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 1200, 'easeInOutQuart');
        });
    };

    /**
     * Handle logo click and set home link active
     * @private
     */
    var _logoClick = function () {
        $(document).on('click', '.masthead__logo, .footer__logo', function (event) {
            event.preventDefault();

            var $link = $(this);

            var data = {};
            data.load_partial = $link.attr('href');
            data.title = $link.text();

            var $nav = $('.nav__wrap');
            $nav.find('.active').removeClass('active');

            History.pushState(data, data.title, $link.attr('href'));
        });
    };

    /**
     * Handle navigation clicks
     * @private
     */
    var _topNav_onClickHandler = function () {

        /**
         * Helper for Show/Hide the nav in the mobile and tablet sizes
         *
         */
        $(document).on('mouseenter', '.nav__wrap', function() {
            $(this).addClass('mouseenter');
        });

        $(document).on('mouseenter', '.nav__wrap', function() {
            $(this).addClass('mouseenter');
        });

        $(document).on('mouseleave', '.nav__wrap', function() {
            $(this).removeClass('mouseenter');
        });

        $(document).on('click', '.nav__menu-icon', function(event) {
            event.preventDefault();

            var $nav_wrap = $('.nav__wrap');
            if ($nav_wrap.hasClass('mouseenter')) {
                $nav_wrap.removeClass('mouseenter');
            } else {
                $nav_wrap.addClass('mouseenter');
            }
        });


        $(document).on('touchend click', '.nav__link', function (event) {
            event.preventDefault();
            event.stopPropagation();

            var $link = $(this);
            var $nav = $('.nav__wrap');

            $nav.find('.active').removeClass('active');
            $link.parent().addClass('active');

            var data = {};
            data.load_partial = $link.attr('href');
            data.title = $link.text();

            History.pushState(data, data.title, $link.attr('href'));
        });
    };

    /**
     * Handle footer nav clicks
     * @private
     */
    var _footerNav_onClickHandler = function () {
        $('.footer__nav').on('click', 'a', function (event) {
            event.preventDefault();

            var $nav = $('.nav__wrap');
            $nav.find('.active').removeClass('active');

            var $link = $(this);

            var data = {};
            data.load_partial = $link.attr('href');
            data.title = $link.text();

            History.pushState(data, data.title, $link.attr('href'));
        });
    };

    var _allPagesAnimateIn = function (callback) {
        HomePage.animateIn(callback);
        AboutPage.animateIn(callback);
        ServicesPage.animateIn(callback);
        SolutionsPage.animateIn(callback);
        SolutionChildPage.animateIn(callback);
        ProjectsPage.animateIn(callback);
        ProjectPage.animateIn(callback);
        InsurancePage.animateIn(callback);
        ContactPage.animateIn(callback);
    };

    var _allPagesAnimateOut = function (callback) {
        HomePage.animateOut(callback);
        AboutPage.animateOut(callback);
        ServicesPage.animateOut(callback);
        SolutionsPage.animateOut(callback);
        SolutionChildPage.animateOut(callback);
        ProjectsPage.animateOut(callback);
        ProjectPage.animateOut(callback);
        InsurancePage.animateOut(callback);
        ContactPage.animateOut(callback);
    };

    var _enableEventHandlers = function() {
        FastClick.attach(document.body);
        _initHistoryHandler();
        _enableExternalLinks();
        _goTopClick();
        _logoClick();
        _topNav_onClickHandler();
        _footerNav_onClickHandler();
    };

    var _disableEventHandlers = function() {};

    return {
        init: function(callback) {
            wh = $(window).height();
            tm = TweenMax;

            $(window).on('resize orientationchange', _resizeHandler);
            $(window).on('scroll', _onScroll);

            _onResize();
            _onScroll();

            $(document).on('lazyloaded', function(){
                _onResize();
            });

            $(window).on('load', function() {
                _onResize();
            });

            $('body').imagesLoaded(function() {
                _onResize();
                _onScroll();
            });

            $('body').removeClass('fade-out');

            $('.footer').on('inview', function() {
                tm.to($(this), 0.6, {opacity: 1, ease: Circ.easeOut, delay: 0.1});
            });

            tm.to($('.masthead'), 0.3, {
                ease: Power1.easeOut, css: {opacity: 1}, onComplete: function () {
                    _enableEventHandlers();
                    _allPagesAnimateIn(callback);
                }
            });
        }
    };
}();

var wh, // window.height
    tm; // TweenMax

var inview = function() {
    var $i = $("[data-scrollspy]").filter(function () {
        if (!$(this).hasClass("inview")) {
            var b = this.getBoundingClientRect()
            if (Math.ceil(b.top) < wh && Math.ceil(b.bottom) > 0) return $(this)
        }
    }).trigger("inview")
};


(function($) {
    'use strict';

    $.fn.removeClassStartingWith = function (filter) {
        $(this).removeClass(function (index, className) {
            return (className.match(new RegExp("\\S*" + filter + "\\S*", 'g')) || []).join(' ')
        });
        return this;
    };

    $(function () {
        App.init(function () {
            console.info('App initialized');
        });
    });

})(jQuery);
